/* =========================================================
   custom-properties.js (Dawn)
   - Selected label: data-selected-wrap + data-selected-out
   - Required guard: cible uniquement [data-req-id]
   ========================================================= */
(() => {
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[custom-properties]', ...a);

  // anti double init
  if (window.__customPropsInit) return;
  window.__customPropsInit = true;

  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const uniq = (arr) => [...new Set(arr)];
  const cssEscape = (v) =>
    (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&');

  /* ---------- Selected label sync ---------- */
  function initSelectedSync(root = document) {
    qsa('[data-selected-wrap]', root).forEach((wrap) => {
      if (wrap.dataset.selectedBound === '1') return;
      wrap.dataset.selectedBound = '1';

      const out = wrap.querySelector('[data-selected-out]');
      if (!out) return;

      const update = () => {
        const checked = wrap.querySelector('input[type="radio"]:checked')
          || wrap.querySelector('input[type="checkbox"]:checked');

        const select = wrap.querySelector('select');

        if (checked) out.textContent = checked.value || '—';
        else if (select) out.textContent = select.value || '—';
        else out.textContent = '—';
      };

      update();
      wrap.addEventListener('change', update);
      wrap.addEventListener('input', update);
    });
  }

  /* ---------- Buttons linked to a form ---------- */
  function getButtonsForForm(form) {
    if (!form || !form.id) return [];
    const formId = form.id;

    const inside = qsa('button[name="add"], button[type="submit"]', form);
    const outside = qsa(
      `button[name="add"][form="${cssEscape(formId)}"], button[type="submit"][form="${cssEscape(formId)}"]`
    );

    const pay = qsa('.shopify-payment-button__button', document).filter((b) => {
      const f = b.getAttribute('form');
      return f === formId || form.contains(b);
    });

    return uniq([...inside, ...outside, ...pay]);
  }

  /* ---------- Required fields ---------- */
  function getRequiredFieldsForForm(form) {
    if (!form) return [];
    const formId = form.id;

    const inside = qsa('[data-req-id]', form);
    const outsideLinked = formId ? qsa(`[data-req-id][form="${cssEscape(formId)}"]`) : [];

    const container =
      form.closest('section[id^="MainProduct-"], .shopify-section, .product')
      || form.closest('main')
      || form.parentElement;

    const nearby = container ? qsa('[data-req-id]', container) : [];

    return uniq([...inside, ...outsideLinked, ...nearby]);
  }

function isMissing(el, form) {
  if (!el || el.disabled) return false;

  // SELECT
  if (el.tagName === 'SELECT') return !el.value;

  // INPUT
  if (el.tagName === 'INPUT') {
    const t = el.type;

    if (t === 'checkbox') return !el.checked;

    if (t === 'radio') {
      const name = el.name;
      if (!name) return false;

      const formId = form && form.id ? form.id : (el.form && el.form.id ? el.form.id : null);

      // IMPORTANT:
      // Les radios peuvent être hors du <form> et liées via form="..."
      // => on cherche dans document, mais en filtrant sur le bon form.
      let selector = `input[type="radio"][name="${cssEscape(name)}"]`;
      if (formId) {
        selector = `${selector}[form="${cssEscape(formId)}"], form#${cssEscape(formId)} ${selector}`;
      }

      const scope = document;
      return !scope.querySelector(`${selector}:checked`);
    }

    return el.required && !el.value;
  }

  return el.required && !el.value;
}


  function labelFor(el) {
    const n = el.getAttribute('data-req-name');
    if (n && n.trim()) return n.trim();

    const block = el.closest('.product-form__input, .product__custom-properties, .field');
    const l = block ? block.querySelector('.form__label, .field__label') : null;
    return l ? l.textContent.trim() : 'une option obligatoire';
  }

  function ensureNote(form, anchorEl) {
    if (!form || !anchorEl) return null;

    let note = form.querySelector('.custom-req-note');
    if (note) return note;

    note = document.createElement('div');
    note.className = 'custom-req-note';
    note.hidden = true;
    anchorEl.parentNode.insertBefore(note, anchorEl);
    return note;
  }

  function flash(note) {
    if (!note) return;
    note.classList.remove('is-flash');
    void note.offsetWidth;
    note.classList.add('is-flash');
    clearTimeout(note.__t);
    note.__t = setTimeout(() => note.classList.remove('is-flash'), 2300);
  }

  const setAttempt = (form, on) => (form.dataset.customReqAttempt = on ? '1' : '');
  const hasAttempt = (form) => form.dataset.customReqAttempt === '1';

  function syncForm(form) {
    if (!form) return null;

    const reqs = getRequiredFieldsForForm(form);
    log('syncForm', form.id, 'reqs:', reqs.length);
    if (!reqs.length) return { ok: true, missing: [], note: null };

    const missing = reqs.filter((el) => isMissing(el, form));
    const ok = missing.length === 0;
    const attempt = hasAttempt(form);

    const btns = getButtonsForForm(form);
    const anchor = btns[0] || form.querySelector('button, .shopify-payment-button__button');
    const note = ensureNote(form, anchor);

    if (note) {
      if (!ok && attempt) {
        const names = uniq(missing.map(labelFor));
        note.innerHTML = `<strong>Action requise :</strong> sélectionnez ${names.join(' · ')}.`;
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    reqs.forEach((el) => {
      const miss = attempt && isMissing(el, form);
      const selectShell = el.closest('.select');
      if (selectShell) selectShell.classList.toggle('custom-req--invalid', miss);
      el.setAttribute('aria-invalid', miss ? 'true' : 'false');
    });

    if (ok) setAttempt(form, false);
    return { ok, missing, note };
  }

  function blockIfMissing(e, form) {
    if (!form) return;

    setAttempt(form, true);
    const res = syncForm(form);
    if (!res || res.ok) return;

    e.preventDefault();
    e.stopPropagation();

    flash(res.note);

    const first = res.missing[0];
    if (first && typeof first.focus === 'function') {
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function bindForm(form) {
    if (!form || form.dataset.customReqInit === '1') return;
    form.dataset.customReqInit = '1';

    form.addEventListener('change', () => syncForm(form), true);
    form.addEventListener('input', () => syncForm(form), true);
    form.addEventListener('submit', (e) => blockIfMissing(e, form), true);

    const bindButtons = () => {
      getButtonsForForm(form).forEach((btn) => {
        if (btn.dataset.customReqBound === '1') return;
        btn.dataset.customReqBound = '1';
        btn.addEventListener('click', (e) => blockIfMissing(e, form), true);
      });
    };

    bindButtons();

    const mo = new MutationObserver(() => bindButtons());
    mo.observe(form, { childList: true, subtree: true });

    syncForm(form);
  }

  function initAll(root = document) {
    initSelectedSync(root);
    qsa('form[id^="product-form-"]', root).forEach(bindForm);
  }

  function safeInit(root) {
    try {
      initAll(root);
    } catch (err) {
      console.error('[custom-properties] JS error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => safeInit(document));
  } else {
    safeInit(document);
  }

  document.addEventListener('shopify:section:load', (e) => safeInit(e.target || document));

  const domObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes || []) {
        if (n && n.nodeType === 1) safeInit(n);
      }
    }
  });
  domObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
// ---- Link custom properties to the real product form (Dawn safe) ----
(() => {
  function linkToProductForm(root = document) {
    const form = root.querySelector('form[id^="product-form-"]');
    if (!form) return;

    const formId = form.id;

    // Tous les inputs/selects custom qui n'ont pas déjà un form correct
    const nodes = root.querySelectorAll(
      '.product__custom-properties select[name^="properties["], .product__custom-properties input[name^="properties["]'
    );

    nodes.forEach((el) => {
      // si déjà dans le form, pas besoin
      if (form.contains(el)) return;

      // si déjà lié au bon form, pas besoin
      if (el.getAttribute('form') === formId) return;

      el.setAttribute('form', formId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => linkToProductForm(document));
  } else {
    linkToProductForm(document);
  }

  document.addEventListener('shopify:section:load', (e) => linkToProductForm(e.target || document));

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes || []) {
        if (n && n.nodeType === 1) linkToProductForm(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
